export default {
  navbar: {
    logOut: "Log Out",
    home: "Home",
    dashboard: "Dashboard",
    screenfull: "Screenfull",
    exitScreenfull: "Exit Screenfull",
    theme: "Theme",
    size: "Global Size",
    stheme: "Personal Theme",
  },
  login: {
    title: "SC E-Log",
    logIn: "Log in",
    username: "UserName",
    password: "Password",
    editPassword: "ModifyPassword",
    oldPassword: "OldPassword",
    newPassword: "NewPassword",
    confirmPassword: "ConfirmPassword",
    confirmModify: "confirm",
    idTootip: "Please enter the correct username",
    passwordTootip: "The login password must not be less than six digits",
  },
  theme: {
    change: "Change Theme",
    documentation: "Theme documentation",
    tips: "Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details.",
  },
  language: {
    message: "Switch language successfully",
  },
  tagsView: {
    refresh: "Refresh",
    close: "Close",
    closeOthers: "Close Others",
    closeAll: "Close All",
  },
  report: {
    edit: "edit",
    delete: "delete",
  },
  menu: {
    home: "Home",
    SystemMangerment: "SystemMangerment",
    RoleManagement: "Role",
    ModulesManagement: "Modules",
    FieldManagement: "Field",
    MenuManagement: "Menu",
    SisManagement: "SISManagement",
    SisModuleManagement: "Modules",
    SisMenuManagement: "Menu",

    baseinfomanagement: "BaseDataManagement",
    workcategorymanagement: "WorkCategoryManagement",
    department: "DepartmentManagement",
    factory: "FactoryManagement", //mock.js中funnameen
    position: "PositionManagement",
    positionrelationship: "PositionRelationshipManagement",
    Operation: "Operation",
    workchildcategorymanagement: "WorkchildCategoryManagement",
    industrycategorymanagement: "IndustryCategoryManagement",
    regionbasismanagement: "RegionManagement",
    projectmanagement: "ProjectManagement",
    //customermanagement: '客户管理',
    agentmanagement: "AgentManagement",
    dailyrecordmanagement: "DailyRecordManagement",
    dailyrecord: "DailyRecord",
    personalmanagement: "PersonalManagement",
    SISGroupManagement: "权限群组管理",
    usermanagement: "UserManagement",
    user: "User",
    password: "Modify password",
    authmanagement: "AuthManagement",
    group: "GroupManagement",
    menu: "MenuManagement",
    servicemanagement: "servicemanagement",
    SISUserToGroupManagement: "UserToGroupManagement",
    SISGroupToMenusManagement: "GroupToMenusManagement",
    orderservicemanagement: "orderservicemanagement",
    orderhandlemanagement: "orderhandlemanagement",
    ElogBasicDataManagement: "BasicDataManagement",
    ElogJobClassification: "JobClassification",
    ElogTechModule: "工作模块",
    ElogTechSubModule: "子模块",
    ElogTechName: "具体名称",
    ElogTechRelate: "技术管理",
    ElogDemand: "需求管理",
    ElogDemandSource: "需求来源",
    ElogDemandObject: "需求对象",
    ElogSuportClassification: "支持类别",
    ElogCustomerRelate: "客户管理",
    ElogIndustry: "行业管理",
    ElogStage: "阶段",
    ElogCustomerClassification: "客户类型",
    ElogSaleModel: "销售模式",
    ElogCustomerRegion: "客户区域",
    ElogCustomer: "客户",
    ElogBU: "所属BU",
    ElogUserClass: "课别",
    ElogUserDepartment: "部门",
    ElogUserInfo: "用户",
    ElogUserRegion: "用户区域",
    ElogUserRelate: "用户管理",
    ElogUserCenter: "个人中心",
    ElogUpdatePassWord: "修改密码",
    ElogResetPassWord: "重置密码",
    ElogRecordManagement: "日志管理",
    ElogRecord: "日志",
    ElogAddRecord: "新增日志",
    ElogUserAuthority: "用户权限",
    ElogAuthorityClass: "权限等级",
    ElogUserAuthorityManagement: "权限管理",
    ElogGetRecord: "查询日志",
    ElogCalendar: "填写日历",
    ElogReportChart: "報表",
    ElogDemandResourceChart: "需求來源",
    ElogJobClassificationChart: "工作分類",
    ElogComplementRate: "月填寫率",
    ElogJobModuleChart: "工作模塊/子模塊",
    ElogBusinessTipChart: "出差占比",
    ElogCustomerApply: "新增客户",
    ElogCustomerConfirm: "客户确认",
    ElogCustomerImport: "客户导入",
    ElogEncodeRelate: "内容编码",
    ElogCodeGenerateItem: "编码组成项",
    ElogCodeClassification: "编码类型",
    ElogCodeItemClassification: "编码细项管理",
    ElogCodeItemDetail: "编码组成项明细",
    ElogCodeDetail: "内容编号",
    ElogAutoMaticCode: "自動編碼",
  },
  common: {
    userno: "userno",
    department: "department",
    userType: "userType",
    sysManagerment: "System administrator",
    managerment: "Administrator",
    generalUsers: "General Users",
    allUserType: "All types",
     remberPassword:"Rember Password",
    search: "Search",
    add: "Add",
    clear: "Clear",
    copyAdd: "Copy Add",
    export: "Export",
    edit: "Edit",
    delete: "Delete",
    menus: "Menus",
    nodes: "Nodes",
    modules: "Modules",
    workCategory: "WorkCategory",
    workChildCategory: "WorkChildCategory",
    industryCategory: "Industry",
    regionManage: "regionManage",
    project: "project",
    customer: "customer",
    agent: "agent",
    position: "position",
    factory: "factory",
    operation: "operation",
    cancel: "cancel",
    confirm: "confirm",
    group: "group",
    enable: "enable",
    disable: "disable",
    allStatus: "allStatus",
    deleted: "deleted",
    yes: "yes",
    no: "no",
    creator: "creator",
    createDate: "createDate",
    node: "node",
    messageSucess: "messageSucess",
    please: "please",
    pleaseSelect: "pleaseSelect",
    pleaseInput: "pleaseInput",
    status: "status",
    resent: "resent",
    description: "description",
    startTime: "startTime",
    endTime: "endTime",
    pleaseSelectTime: "Please Select Time",
    pleaseSelectGenerateItem: "Please Select Encoding components",
  },
  group: {
    groupId: "Group Id",
    groupName: "Group Name",
    status: "Group Status",
    description: "Group Description: ",
    menusContent: "Menus Content：",
    selectedMenus: "Selected Menus：",
    updatedGroup: "Update Group",
    userMembers: "User Members",
    selectedMembers: "Selected Member",
    menuGroup: "menu Group",
  },
  nodes: {
    nodeId: "Node Id",
    nodeName: "Node Name",
    modulePath: "Module Path",
    taskType: "Task Type",
    taskType0: "A single execution",
    taskType1: "Periodically execution",
    taskType2: "Batch execution",
    status: "Node Status",
    nodeNameNotNull: "Node name is not null",
    modulePathNotNull: "Module path is not null",
  },
  user: {
    userId: "UserNo",
    loginName: "UserName",
    groupName: "GroupName",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    editLevel: "EditLevel",
    reset: "Reset",
    confirm: "Reset the password?",
    successReset: "successReset",
    department: "department",
    email: "EMAIL",
    userType: "userType",
    commonUser: "commonUser",
    superUser: "superUser",
    levelGroup: "levelGroup",
    titlesLeft: "All permission groups",
    titlesRight: "Designated permission group",
    mailTooltip: "Please enter the correct email address",
  },

  menus: {
    menuName: "Menu Name",
    displayName: "Display Name",
    parentName: "Parent Name",
    moduleName: "Module Name",
    iconName: "Icon Name",
    api: "API",
    menuUrl: "Menu Url",
    status: "Menu Status",
    menuNameEn: "Menu English Name",
    menuNameEnMsg: "English must be filled in",
    usable: "Is the menu available",
    confirm: "confirm",
  },
  modules: {
    moduleName: "Module Name",
    moduleId: "Module Id",
    status: "Status",
    description: "Module Description",
  },
  order: {
    groupId: "Group Id",
    uploadTime: "Upload Time",
    uploadEndTime: "Upload Endtime",
    mergeGroup: "Merge Group",
    weekly: "Weekly",
    smtLineNo: "SMT LineNo",
    mono: "Mono",
    engNo: "EngNo",
    productNo: "ProductNo",
    monoQty: "MonoQty",
    stdTime: "StdTime",
    planStartTime: "Plan Start Time",
    pcbNo: "PCBNo",
    lineNo: "LineNo",
    prfFactory: "Prd Factory",
    status: "Status",
    no: "No",
  },
  route: {
    home: "home",
    password: "password",
    user: "user",
    department: "department",
    machine: "machine",
    materialToFeeder: "materialToFeeder",
    node: "node",
    process: "process",
    message: "message",
    processDistribution: "processDistribution",
    report: "report",
    sisModule: "Module",
    sisMenu: "Menu",
    sisGroup: "Group",
    uploadSchedule: "uploadSchedule",
    orderMerge: "orderMerge",
    board: "board",
    workCategory: "workCategory",
    workChildCategory: "workChildCategory",
    industryCategory: "industryCategory",
    regionManage: "regionManage",
    project: "project",
    customer: "customer",
    agent: "agent",
    factory: "factory", //对应页面标籤的标题
    operation: "operation",
    position: "position",
    positionRelationship: "positionRelationship",
    dailyRecord: "dailyRecord",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    group: "Group",
    menus: "Menu",
    orderService: "orderService",
    orderServiceForm: "orderServiceForm",
    orderHandle: "orderHandle",
    orderHandleForm: "orderHandleForm",
    jobClassification: "Job Classification",
    techModule: "Job Module",
    techSubModule: "Job SubModule",
    techName: "Specific Name",
    demandSource: "DemandSource",
    demandObject: "DemandObject",
    suportClassification: "Support Classification",
    industry: "Industry",
    stage: "Stage",
    customerClassification: "CustomerType",
    saleModel: "SaleModel",
    customerRegion: "CustomerRegion",
    customerInfo: "Customer",
    customerRelate: "CustomerManagement",
    BU: "BU",
    userClass: "Class",
    userDepartment: "Department",
    userInfo: "User",
    userRegion: "userRegion",
    userRelate: "UserManagement",
    updatePassWord: "Modify Password",
    resetPassword: "Reset Password",
    record: "Record",
    addRecord: "AddRecord",
    authorityClass: "AuthorityClass",
    userAuthorityManagement: "AuthorityManagement",
    getRecord: "Query Record",
    getElogCalendar: "Elog Calendar",
    businessTipChart: "出差占比",
    complementRate: "月填寫率",
    demandResourceChart: "需求來源",
    jobClassificationChart: "工作分類",
    jobModuleChart: "工作模塊/子模塊",
    customerApply: "Add Customer",
    customerConfirm: "Customer Confirm",
    codeGenerateItem: "Encoding components",
    codeClassification: "Encoding type",
    codeItemClassification: "Encoding detail management",
    codeItemDetail: "Code composition item details",
    codeDetail: "Encode Number",
    autoMaticCode: "AutoMatic Coding",
  },
  dailyRecord: {
    date: "Date",
    selectDate: "SelectDate",
    workingHours: "workingHours",
    workCategory: "workCategory",
    workChildCategory: "workChildCategory",
    industryCategory: "industry",
    regionManage: "regionManage",
    customer: "customer",
    equipment: "equipment",
    content: "content",
  },
  editPassword: {
    editPasswordTooltip: "The modified password cannot be less than six digits",
    confirmNotNull: "Confirm password cannot be empty",
    confirmTooltip: "The two password inputs are inconsistent",
    successAlert: "Password modification successful",
    successReset: "Password reset successful",
  },
  logout: {
    title: "Exit",
    tip: "Are you sure you want to exit?",
  },
  dialog: {
    screenfullNotSupport:
      "The current browser does not support full screen. Please use the latest version of the browser",
  },
  e_log: {
    jobClassification: "Job Classification",
    description: "Description",
    techModule: "Job Module",
    techSubModule: "Job SubModule",
    techName: "Specific Name",
    demandSource: "DemandSource",
    demandObject: "DemandObject",
    suportClassification: "SupportClassification",
    industry: "Industry",
    stage: "Stage",
    customerClassification: "CustomerType",
    saleModel: "SaleModel",
    customerRegion: "CustomerRegion",
    customer: "Customer",
    customerRelate: "CustomerManagement",
    channelName: "Channel",
    BU: "BU(Multiple-Choice)",
    BU1: "BU1",
    BU2: "BU2",
    userClass: "Class",
    userDepartment: "Department",
    userInfo: "User",
    userRegion: "UserRegion",
    userRelate: "UserManagement",
    userName: "userName",
    region: "Region",
    userEnName: "EnglishName",
    userId: "User ID",
    updatePassWord: "Modify Password",
    resetPassword: "Reset Password",
    codeName: "Encode",
    customerName: "CustomerName",
    startDate: "StartDate",
    endDate: "EndDate",
    record: "Record",
    addRecord: "Edit Record",
    workDate: "WorkDate",
    pleaseSelectDate: "Please Select Date",
    pleaseSelect: "Please Select",
    pleaseInput: "Please Input",
    codeNo: "Code ID",
    demandDate: "Demand Date",
    projectName: "Project Name",
    deltaInternal: "需求窗口",
    Yes: "Yes",
    No: "NO",
    isScDeveloped: "是否SC开发",
    systemArchitecture: "Product/System Architecture",
    content: "具体内容",
    isEnd: "项目是否结案",
    WorkOut: "出差",
    WorkHome: "办公室",
    JobLocation: "是否出差",
    IsChannelPresent: "渠道商是否到场",
    IsFAEPresent: "FAE是否到场",
    effectiveHours: "effectiveHours",
    effectiveHoursLimit: "0-24内有效數字",
    effectiveHoursLeave: "0-8内有效數字",
    projectStartDate: "projectStartDate",
    estimatedEndDate: "estimatedEndDate",
    cancel: "Cancel",
    confirm: "Confirm",
    authorityClass: "AuthorityClass",
    userAuthorityManagement: "AuthorityManagement",
    dateLimit: "时间范围",
    authorityClassNo: "AuthorityClass NO",
    customerConfirm: "Customer Confirm",
    codeGenerateItem: "Encoding components",
    codeClassification: "Encoding type",
    codeItemClassification: "Encoding detail management",
    generateItemOrder: "编码项序号",
    codeItemDetail: "Code composition item details",
    generateItemDetailsCode: "Encode",
    codeDetail: "Encode Number",
    role: "role",
    bindingName: "权限绑定",
    administrators: "Administrators",
    normalUser: "普通用户",
    IncludeCompetitors: "是否包含竞品",
    Competitors: "竞品信息",
    all: "",
    dataCount: "pieces of data in total",
    pleaseInputSimplySelect: "请使用简体输入",
    pleaseInputKeysTosearch: "请输入简体关键字",
    Loading: "Loading",
    back: "Back",
    selectCodeItem: "Auto Coding item",
    autoCoding: "Auto coding",
  },
  BU: {
    MDSBU: "MDSBU:    变频器",
    IMSBU: "IMSBU:    伺服",
    IMS_RABD: "IMS-RABD:    机器人",
    ICSBU: "ICSBU:    PLC/HMI",
    SSM_LOB: "SSM_LOB:   视觉/温控器",
    AMBU: "AMBU:    智能制造",
    ISD_LOB: "ISD LOB:    CNC/CADCAM/橡塑行業",
    FASBD: "FASBD:    MES&SECS-GEM",
    IEMD:"IEMD:  綫馬/電鎖/電動夾爪",
    Other: "Other",
  },
  Chart: {
    start_month: "Start Month",
    end_month: "End Month",
    separator: "-",
    jobLocation_ratio_total: "Total Percentage of travel/office time",
    jobLocation_ratio_month: "Monthly Percentage of travel/office time",
    workOut_home: "Travel/Office",

    workOut_home_total: "Total Percentage of travel_office time",
    workOut_home_month: "Monthly Percentage of travel_office time",
    hours: "Hours(h)",
    table_workOut_home: "travel_office",
    demandResource_ratio_total: "Total Time proportion of each demand source",
    DGC_ratio_month:
      "Monthly The percentage of working hours required from DGC(%)",
    Overseas_ratio_month:
      "Monthly The percentage of working hours required from overseas(%)",
    demandResource: "Demand Source",
    jobclassification_ratio_total:
      "Total Each work classification time proportion",
    jobclassification_ratio_month:
      "Monthly Each work classification time proportion",
    jobclassification: "Work classification",
    name: "name",
    userClassName: "Class",
    fillingRatio: "Monthly filling rate",
    month: "month",
    table_jobModule_subModule: "Working module Submodule",
    table_jobModule_subModule_hours: "Work module submodule time",
    jobModule_subModule: "Working module/Submodule",
    jobModule_subModule_hours: "Work module/submodule time",
    jobModule_subModule_hours_ratio: "Work module/submodule work time ratio",
    ratio: "Ratio",
    weekHours: "Fill in hours this week",
    monthHours: "Fill in hours this month",
    monthStandardHours: "Standard hours for this month",
    itemRatio:"Item Ratio"
  },
};
